/* Autogenerated file. Do not edit manually */
/* eslint-disable */
/* @ts-nocheck */

import { BaseOpenapiClient } from 'foca-openapi';

export namespace OpenapiClientParrotVault {
  export type GetVaultCoinsResponse = {
    coin_type: string;
    name: string;
    symbol: string;
    decimals: number;
    icon: string;
    description: string;
    price_usd: number;
    price_source: 'coingecko' | 'pyth';
  }[];
  export type GetVaultInvitePointsQuery = { owner: string };
  export type GetVaultInvitePointsResponse = {
    point: string;
    deposit_point: string;
    referral_point: string;
    ranking: number;
    valid_invite_count: number;
  };
  export type GetVaultInviteCodeQuery = { owner: string };
  export type GetVaultInviteCodeResponse = { code: string };
  export type GetVaultInviteRankingsQuery = { page?: number; limit?: number };
  export type GetVaultInviteRankingsResponse = {
    page: number;
    limit: number;
    total: number;
    result: { ranking: number; point: string; wallet_address: string }[];
  };
  export type GetVaultStatsPortfolioQuery = { owner: string };
  export type GetVaultStatsPortfolioResponse = {
    balance: string;
    /**
     * Balance last update time
     */
    timestamp: number;
  };
  export type GetVaultStatsSummaryResponse = {
    wallet_count: number;
    revenue_usd: number;
    revenue_24h_usd: number;
    tvl: number;
  };
  export type GetVaultStatsChartTvlResponse = { timestamp: number; tvl: number }[];
  export type GetVaultStatsChartRevenuesResponse = { timestamp: number; revenue_usd: number }[];
  export type GetVaultVaultsQuery = {
    owner?: string;

    /**
     * Coin type, support separator x,x,x
     */
    tokens?: string[];
    sort?: 'liquidity_usd' | 'apy' | 'protocol';
    direction?: 'asc' | 'desc';
    protocol?: string;
    page?: number;
    limit?: number;
  };
  export type GetVaultVaultsResponse = {
    page: number;
    limit: number;
    total: number;
    result: {
      vault_id: string;
      protocol: string;
      pool_id: string;
      position_id: string;
      name: string;
      slippage: string;
      fee_rate: string;
      tick_lower: number;
      tick_upper: number;
      price_lower: number;
      price_upper: number;
      price_current: number;
      coin_type_a: string;
      coin_type_b: string;
      coin_amount_a: string;
      coin_amount_b: string;
      liquidity: string;
      liquidity_usd: string;
      liquidity_a_usd: string;
      liquidity_b_usd: string;
      total_share: string;
      apr: number;
      apy: number;
      balance: string;
    }[];
  };
  export type GetVaultVaultsByIdQuery = { owner?: string };
  export type GetVaultVaultsByIdParams = { id: string };
  export type GetVaultVaultsByIdResponse = {
    vault_id: string;
    protocol: string;
    pool_id: string;
    position_id: string;
    name: string;
    slippage: string;
    fee_rate: string;
    tick_lower: number;
    tick_upper: number;
    price_lower: number;
    price_upper: number;
    price_current: number;
    coin_type_a: string;
    coin_type_b: string;
    coin_amount_a: string;
    coin_amount_b: string;
    liquidity: string;
    liquidity_usd: string;
    liquidity_a_usd: string;
    liquidity_b_usd: string;
    total_share: string;
    apr: number;
    apy: number;
    balance: string;
  };
  export type GetVaultVaultsMineQuery = {
    owner: string;
    sort?: 'liquidity_usd' | 'apy' | 'protocol';
    direction?: 'asc' | 'desc';
    protocol?: string;
    page?: number;
    limit?: number;
  };
  export type GetVaultVaultsMineResponse = {
    page: number;
    limit: number;
    total: number;
    result: {
      vault_id: string;
      protocol: string;
      pool_id: string;
      position_id: string;
      name: string;
      slippage: string;
      fee_rate: string;
      tick_lower: number;
      tick_upper: number;
      price_lower: number;
      price_upper: number;
      price_current: number;
      coin_type_a: string;
      coin_type_b: string;
      coin_amount_a: string;
      coin_amount_b: string;
      liquidity: string;
      liquidity_usd: string;
      liquidity_a_usd: string;
      liquidity_b_usd: string;
      total_share: string;
      apr: number;
      apy: number;
      balance: string;
    }[];
  };
  export type PostVaultInviteNonceBody = { wallet: string };
  export type PostVaultInviteNonceResponse = { nonce: string };
  export type PostVaultInviteInvitedBody = { code: string; signature: string; wallet: string };
}

export class OpenapiClientParrotVault<T extends object = object> extends BaseOpenapiClient<T> {
  get<K extends keyof OpenapiClientParrotVault_get_paths>(
    uri: K,
    ...rest: K extends
      | '/vault/coins'
      | '/vault/invite/rankings'
      | '/vault/stats/summary'
      | '/vault/stats/chart/tvl'
      | '/vault/stats/chart/revenues'
      | '/vault/vaults'
      ? [
          opts?: OpenapiClientParrotVault_get_paths[K]['request'] &
            BaseOpenapiClient.UserInputOpts<T>,
        ]
      : [
          opts: OpenapiClientParrotVault_get_paths[K]['request'] &
            BaseOpenapiClient.UserInputOpts<T>,
        ]
  ): Promise<OpenapiClientParrotVault_get_paths[K]['response']> {
    return this.request(uri, 'get', ...rest);
  }

  post<K extends keyof OpenapiClientParrotVault_post_paths>(
    uri: K,
    ...rest: [
      opts: OpenapiClientParrotVault_post_paths[K]['request'] & BaseOpenapiClient.UserInputOpts<T>,
    ]
  ): Promise<OpenapiClientParrotVault_post_paths[K]['response']> {
    return this.request(uri, 'post', ...rest);
  }

  protected override pickContentTypes(uri: string, method: string) {
    return contentTypes[method + ' ' + uri] || [void 0, void 0];
  }
}

interface OpenapiClientParrotVault_get_paths {
  '/vault/coins': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrotVault.GetVaultCoinsResponse;
  }>;
  '/vault/invite/points': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrotVault.GetVaultInvitePointsQuery;
    };
    response: OpenapiClientParrotVault.GetVaultInvitePointsResponse;
  }>;
  '/vault/invite/code': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrotVault.GetVaultInviteCodeQuery;
    };
    response: OpenapiClientParrotVault.GetVaultInviteCodeResponse;
  }>;
  '/vault/invite/rankings': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrotVault.GetVaultInviteRankingsQuery;
    };
    response: OpenapiClientParrotVault.GetVaultInviteRankingsResponse;
  }>;
  '/vault/stats/portfolio': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrotVault.GetVaultStatsPortfolioQuery;
    };
    response: OpenapiClientParrotVault.GetVaultStatsPortfolioResponse;
  }>;
  '/vault/stats/summary': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrotVault.GetVaultStatsSummaryResponse;
  }>;
  '/vault/stats/chart/tvl': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrotVault.GetVaultStatsChartTvlResponse;
  }>;
  '/vault/stats/chart/revenues': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;
    };
    response: OpenapiClientParrotVault.GetVaultStatsChartRevenuesResponse;
  }>;
  '/vault/vaults': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrotVault.GetVaultVaultsQuery;
    };
    response: OpenapiClientParrotVault.GetVaultVaultsResponse;
  }>;
  '/vault/vaults/{id}': BaseOpenapiClient.Prettify<{
    request: {
      query?: OpenapiClientParrotVault.GetVaultVaultsByIdQuery;
      params: OpenapiClientParrotVault.GetVaultVaultsByIdParams;
    };
    response: OpenapiClientParrotVault.GetVaultVaultsByIdResponse;
  }>;
  '/vault/vaults/mine': BaseOpenapiClient.Prettify<{
    request: {
      query: OpenapiClientParrotVault.GetVaultVaultsMineQuery;
    };
    response: OpenapiClientParrotVault.GetVaultVaultsMineResponse;
  }>;
}
interface OpenapiClientParrotVault_post_paths {
  '/vault/invite/nonce': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientParrotVault.PostVaultInviteNonceBody;
    };
    response: OpenapiClientParrotVault.PostVaultInviteNonceResponse;
  }>;
  '/vault/invite/invited': BaseOpenapiClient.Prettify<{
    request: {
      query?: object;

      body: OpenapiClientParrotVault.PostVaultInviteInvitedBody;
    };
    response: unknown;
  }>;
}

const contentTypes: Record<
  string,
  [
    BaseOpenapiClient.UserInputOpts['requestBodyType'],
    BaseOpenapiClient.UserInputOpts['responseType'],
  ]
> = {};
